import React from "react"

import Header from "../components/header"
import GetInTouch from "../components/getintouch"
import Footer from "../components/footer"

// Central source of truth for page <title>s so every route ships a unique,
// descriptive, non-empty title in the SSR build (WCAG 2.4.2 Page Titled).
// Pages that render their own <Seo title="..."> override this (their Helmet
// mounts deeper), but this guarantees the ~29 pages without <Seo> — including
// the home page — are never left with an empty <title>.
const PAGE_TITLES = {
  "/": "Wealth Management & Investment Advisory",
  "/about-us/who-we-are": "Who We Are",
  "/about-us/our-philosophy": "Our Philosophy",
  "/about-us/why-choose-us": "Why Choose Us",
  "/services/offerings": "Offerings",
  "/services/client-journey": "Client Journey",
  "/services/client-engagement": "Client Engagement",
  "/services/fee-philosophy": "Fee Philosophy",
  "/services/offerings/comprehensive-wealth-management": "Comprehensive Wealth Management",
  "/services/offerings/direct-equities-advisory": "Direct Equities Advisory",
  "/services/offerings/mutual-funds-advisory": "Mutual Funds Advisory",
  "/services/offerings/second-look": "Second Look",
  "/clients/business-owner": "Business Owners",
  "/clients/professional-salaried-employee": "Professionals",
  "/clients/woman": "Women",
  "/clients/retirees": "Retirees",
  "/resources/blog": "Blog",
  "/resources/blog/selecting-a-fund-manager": "Selecting a Fund Manager",
  "/resources/media": "Media",
  "/resources/tools": "Tools",
  "/resources/tools/5-minute-health-check": "5 Minute Financial Health Check",
  "/resources/tools/investment-advisory": "Investment Advisory",
  "/resources/tools/risk-profile": "Risk Profile",
  "/resources/tools/thankyou": "Thank You",
  "/resources/book-summaries": "Book Summaries",
  "/resources/book-summaries/fooled-by-randomness-nassim-nicholas-taleb":
    "Fooled by Randomness — Nassim Nicholas Taleb",
  "/resources/book-summaries/influence-the-psychology-of-persuasion-by-robert-b-cialdini":
    "Influence: The Psychology of Persuasion — Robert B. Cialdini",
  "/resources/book-summaries/one-up-on-wall-street": "One Up On Wall Street",
  "/resources/book-summaries/the-little-book-that-builds-wealth-pat-dorsey":
    "The Little Book That Builds Wealth — Pat Dorsey",
  "/resources/book-summaries/the-most-important-thing-howard-marks":
    "The Most Important Thing — Howard Marks",
  "/statutory": "Statutory",
  "/statutory/ria": "RIA",
  "/statutory/pms": "PMS",
  "/contact-us": "Contact Us",
  "/disclaimer": "Disclaimer",
}

// Turn "/resources/book-summaries/one-up-on-wall-street" into "One Up On Wall
// Street" as a safety net for any route not in the map above (incl. future ones)
// so a page can never fall back to an empty title.
function titleFromPath(pathname) {
  const slug = pathname.replace(/\/$/, "").split("/").filter(Boolean).pop()
  if (!slug) return null
  return slug
    .replace(/-/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase())
}

export default function Layout({ children, location }) {
  // Use the location prop provided by gatsby-plugin-layout so the exclusion
  // also applies during server-side rendering (window is undefined at build).
  const pathname =
    location?.pathname ?? (typeof window !== "undefined" ? window.location.pathname : "")
  let hideGetInTouch =
    pathname.includes("disclaimer") || pathname.includes("contact-us") ? true : false

  // Treat an empty pathname (root page during SSR, where location.pathname can
  // be undefined) the same as "/" so the home page gets its mapped title.
  const normalizedPath = !pathname || pathname === "/" ? "/" : pathname.replace(/\/$/, "")
  // Short, per-route title. The base <Header>'s <Seo> renders it as
  // "<pageTitle> | Apricus Wealth Advisors". Pages that use a header-wrapper
  // (which sets its own <Seo title>) override this with their heroTitle.
  const pageTitle = PAGE_TITLES[normalizedPath] ?? titleFromPath(normalizedPath)

  return (
    <>
      <a href="#main-content" class="skip-link">
        Skip to Main Content
      </a>

      <Header pageTitle={pageTitle} />

      <div class="clearfix"></div>

      <main id="main-content">
        {children}

        {!hideGetInTouch && (
          <>
            <div class="clearfix"></div>

            <GetInTouch />
          </>
        )}
      </main>

      <div class="clearfix"></div>

      <Footer />
    </>
  )
}
